import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const FloorsListPage = lazy(() => import('./FloorsListPage'));
const FloorDetailPage = lazy(() => import('./FloorDetailPage'));

export const floorRoutes: RouteObject[] = [
  {
    path: 'floors',
    element: (
      <ProtectedRoute action="floors:view">
        <FloorsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'floors/:id',
    element: (
      <ProtectedRoute action="floors:view">
        <FloorDetailPage />
      </ProtectedRoute>
    ),
  },
];
